export default Object.freeze({
  MAP: 1,
  TABLE: 2,
  PROFILE: 3,
});
